'use strict';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import locale from 'browser-locale';
import ZHTWLang from '../lang/zh-tw';
// import ZHCNLang from './lang/zh-cn.js';
// import ENLang from './lang/en';
import KOLang from '../lang/ko';
const msg = {
  // en: ENLang,
  // 'en-au': ENLang,
  // 'en-bz': ENLang,
  // 'en-ca': ENLang,
  // 'en-cb': ENLang,
  // 'en-ie': ENLang,
  // 'en-jm': ENLang,
  // 'en-nz': ENLang,
  // 'en-ph': ENLang,
  // 'en-za': ENLang,
  // 'en-tt': ENLang,
  // 'en-gb': ENLang,
  // 'en-us': ENLang,
  // 'en-zw': ENLang,
  // zh: ZHCNLang,
  // 'zh-cn': ZHCNLang,
  'zh-hk': ZHTWLang,
  'zh-mo': ZHTWLang,
  'zh-sg': ZHTWLang,
  'zh-tw': ZHTWLang,
  // 'zh-chs': ZHCNLang,
  'zh-cht': ZHTWLang,
  ko: KOLang,
  'ko-kr': KOLang
};
let language = '';
if (localStorage.getItem('lang')) {
  language = localStorage.getItem('lang');
} else {
  language = locale().toLowerCase();
}
if (language !== 'zh-tw' && language !== 'zh-cn' && language !== 'zh') {
  language = 'ko';
  document
    .querySelector('meta[name="description"]')
    .setAttribute(
      'content',
      '소녀스튜디오(trigirls studio)는 모바일 게임 서비스  회사입니다. 상품이름은 <신명> <강림：망령인도자>등입니다.'
    );
} else {
  language = 'zh-tw';
  document
    .querySelector('meta[name="description"]')
    .setAttribute(
      'content',
      '少女工作室(trigirls stuio)是一家手機遊戲服務供應公司。遊戲產品包括：「神命：天選之人」「九州俠影錄」等.'
    );
}
if (msg[language] === undefined) {
  language = 'ko';
}
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: language,
  messages: msg
});

export default i18n;



// WEBPACK FOOTER //
// ./src/common/js/i18n.js